module.exports = __webpack_public_path__ + "static/media/appoptics-logo-white.d7e7e302.svg";